import { Box, Button, SxProps, Typography } from "@mui/material";
import { useMemo } from "react";
import LensIcon from "@mui/icons-material/Lens";

type Props = {
  labels: string[];
  setLabels: (value: string[]) => void;
};

export default function Legend({ labels, setLabels }: Props) {
  const values = ["thisYear", "lastYear"];
  const iconSx: SxProps = { width: "12px", mr: 1 };
  const btnSx: SxProps = { "&:hover": { background: "none" } };

  const labelsToggle = (value: string) => () => {
    let newValues = [...labels];
    labels.includes(value) ? newValues = labels.filter(l => l !== value) : newValues.push(value);
    setLabels(newValues);
  }

  const textSx = useMemo<SxProps[]>(() => {
    return values.map(v => ({
      fontWeight: 600,
      fontSize: 12,
      textDecoration: !labels.includes(v) ? "line-through" : "none"
    }))
  }, [labels]);

  return (
    <Box sx={{ ml: 3, display: "flex", gap: 2 }} >
      <Button disableRipple sx={btnSx} onClick={labelsToggle(values[0])} >
        <LensIcon sx={iconSx} color="primary" />
        <Typography color="secondary" sx={textSx[0]} >
          This Year
        </Typography>
      </Button>
      <Button disableRipple sx={btnSx} onClick={labelsToggle(values[1])} >
        <LensIcon sx={{ ...iconSx, color: "#D758DF" }} />
        <Typography color="secondary" sx={textSx[1]} >
          Last Year
        </Typography>
      </Button>
    </Box>
  )
}